import React, {useEffect} from 'react';
import {initializeFlixMediaData} from "@/animations/responsive/flixMedia";
import {Description} from "@/components/responsive/product/layer/description/Description";


const FlixMedia = ({ labelName, id, unitPrice, soldBy, description }) => {

    useEffect(() => {
        initializeFlixMediaData(labelName, id, unitPrice, soldBy);
    }, []);

    return (
        <div id="flix-inpage">
            {soldBy === 'MKP' && <Description description={description} /> }
        </div>
    );
}

export default FlixMedia;
